import React, { useState } from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BsThreeDots } from "react-icons/bs";
import { useTheme } from "../../../../style/theme";


const arrNew = [
  {
    img_url: "/images/profileImg1.png",
    name: "Amanda Throne",
    attendence: "Present",
    role: "Software Developer",
    time: "Clocked-In",
  },
  {
    img_url: "/images/profileImg2.png",
    name: "Amina Kumar",
    attendence: "Absent",
    role: "QA Tester",
    time: "Not Yet Clocked-In",
  },
  {
    img_url: "/images/profileImg2.png",
    name: "Daniel Thompson",
    attendence: "Leave",
    role: "Frontend Developer",
    time: "Not Yet Clocked-In",
  },
  {
    img_url: "/images/profileImg4.png",
    name: "Dave Maxwell",
    attendence: "Present",
    role: "Frontend Developer",
    time: "Clocked-In",
  },
  {
    img_url: "/images/profileImg5.png",
    name: "Dwayne Graham",
    attendence: "Present",
    role: "Backend Developer",
    time: "Clocked-In",
  },
];

export default function Reportee({ arr , view }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const options = ["Chat", "Audio Call", "Video Call"];
  const ITEM_HEIGHT = 48;
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const {mode} = useTheme()
  if (!arr || arr?.length === 0) {
    return (
      <Box className="w-full p-4 flex justify-center items-center text-gray-500 text-sm">
        No data found
      </Box>
    );
  }
  return arr?.map((items, i) => (
    <Box
      
      key={i}
      className={`w-full h-full flex gap-3 p-2 flex-row justify-center
        items-center rounded-md ${mode === "light" ?"bg-[#F7F9FC]":"bg-[#181818]"} cursor-pointer `} 
         >
      <div
        onClick={() => {
          navigate("/performance/view");
        }}
        className="w-full flex gap-3 flex-row justify-start items-center text-start"
      >
        <div>
          <img
            alt="Steward Graham"
            sx={{ height: "35px", width: "35px" }}
            src={items.img_url}
          />
        </div>
        <div className="text-sm">
          <div className="flex gap-2 items-center">
            <h1>{items.name}</h1>

            <div className="flex gap-1 items-center">
              <div
                className={`w-[8px] h-[8px] rounded-full ${
                  items.attendence === "Present"
                    ? "bg-[#0088ff]"
                    : items.attendence === "Absent"
                    ? "bg-[#FF9B05]"
                    : "bg-[#44B14F]"
                }`}
              />
              <h1 className=" text-[12px] font-[400]">
                {items.attendence}
              </h1>
            </div>
          </div>
          <div className="flex gap-2 items-center">
            <h1 className="text-[#A5A5A5] text-[14px] font-[400]">
              {items.role}
            </h1>
            <h1
              className={`text-[12px] font-[400] ${
                items.time === "Clocked-In"
                  ? "text-[#0088ff]"
                  : "text-[#F13B3B]"
              }`}
            >
              {items.time}
            </h1>
          </div>
        </div>
      </div>

      <div className="min-w-10">
        <>
          <BsThreeDots color="#3F3F3F" onClick={handleClick} />

          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
              paper: {
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "20ch",
                  backgroundColor:mode === "light" ? "#fff" : "#1B1B1B",
                },
              },
            }}
          >
            {options.map((option) => (
              <MenuItem
                key={option}
                selected={option === "Pyxis"}
                onClick={handleClose}
              >
                {option}
              </MenuItem>
            ))}
          </Menu>
        </>
      </div>
    </Box>
  ));
}
